import React from 'react';
import PropTypes from 'prop-types';
import styles from '../shared/styles';

const Category = props => {
  const { label, value, list, required, onChange } = props;

  const requiredRender = required ? <span style={styles.inputLabelRequire}>*</span> : null;

  return (
    <div className="row" style={styles.rowDivision}>
      <div id="category" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <div style={styles.inputLabelWrapper}>
          {label} {requiredRender}
        </div>
        <div style={{ maxWidth: 370 }} className="dropdown">
          <div
            style={styles.dropdownWrapper}
            className="btn dropdown-toggle"
            data-toggle="dropdown"
            id="addSoundcastChooseCategoryBtnTest"
          >
            <div style={styles.dropdownTitle}>
              <span>{value || 'Choose category'}</span>
              <span style={styles.dropdownCaret} className="caret" />
            </div>
          </div>
          <ul style={{ padding: 0, border: 'none' }} className="dropdown-menu categoriesMenuTest">
            {list.map((item, i) => (
              <li style={{ fontSize: '16px' }} key={`category_option${i}`}>
                <button style={styles.dropdownButton} onClick={() => onChange(item)}>
                  {item}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

Category.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  list: PropTypes.array,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};

Category.defaultProps = {
  label: 'Category',
  value: '',
  list: [],
  required: false,
  onChange: () => {},
};

export default Category;
